import { render, staticRenderFns } from "./user-details.vue?vue&type=template&id=e2c134da&scoped=true&"
import script from "./user-details.ts?vue&type=script&lang=ts&"
export * from "./user-details.ts?vue&type=script&lang=ts&"
import style0 from "./user-details.scss?vue&type=style&index=0&id=e2c134da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c134da",
  null
  
)

export default component.exports